const ROOT = `${process.env.REACT_APP_URL_API_V2}properties/types/`
// const ROOT = 'properties/types/'

export default {
	arrayListDropdown: `${ROOT}`
}
